import { render } from "./OAuthBreadcrumbs.vue?vue&type=template&id=ff804580"
import script from "./OAuthBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./OAuthBreadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__